import { useAuthorizationSlice } from 'app/containers/Authorization/slice';
import { selectSelectedCompanyId } from 'app/containers/Company/slice/selectors';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectIsInitEnvsLoading,
  selectSelectedEnvId,
} from '../../slice/selectors';

interface IProps {
  children: React.ReactChild;
}

const HiikoEnvWrapper = (props: IProps) => {
  const dispatch = useDispatch();

  const initLoading = useSelector(selectIsInitEnvsLoading);
  const envId = useSelector(selectSelectedEnvId);
  const companyId = useSelector(selectSelectedCompanyId);

  const { actions: authActions } = useAuthorizationSlice();

  useEffect(() => {
    if (envId) {
      dispatch(authActions.getUserEnvPermissions(envId));
    }
  }, [dispatch, authActions, envId]);

  useEffect(() => {
    if (envId) {
      if (companyId) {
        dispatch(authActions.getUserCompanyPermissions({ envId, companyId }));
      } else {
        dispatch(authActions.setUserCompanyPermissions(null));
      }
    }
  }, [dispatch, authActions, envId, companyId]);

  if (initLoading) {
    return null;
  }

  return <> {props.children} </>;
};

export default HiikoEnvWrapper;
